import { useCurrentFrame, useVideoConfig, interpolate, Easing, AbsoluteFill } from "remotion";
import { loadFont } from "@remotion/google-fonts/Inter";
import { loadFont as loadDevanagari } from "@remotion/google-fonts/NotoSansDevanagari";
import type { InfoBoxData } from "./types";

const { fontFamily } = loadFont("normal", { weights: ["400", "600", "700", "800"], subsets: ["latin"] });
const { fontFamily: devFont } = loadDevanagari("normal", { weights: ["400", "700"], subsets: ["devanagari"] });

const GOLD = "#D4A853";
const BG = "rgba(0,0,0,0.86)";
const BORDER_GOLD = "rgba(212,168,83,0.4)";

export const InfoBox: React.FC<{ data: InfoBoxData; durationInFrames: number }> = ({ data, durationInFrames }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const fadeIn = interpolate(frame, [0, Math.round(0.4 * fps)], [0, 1], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
  });
  const fadeOut = interpolate(frame, [durationInFrames - Math.round(0.5 * fps), durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });
  const slideY = interpolate(frame, [0, Math.round(0.4 * fps)], [20, 0], {
    extrapolateRight: "clamp", extrapolateLeft: "clamp",
    easing: Easing.bezier(0.16, 1, 0.3, 1),
  });

  return (
    <AbsoluteFill style={{ opacity: fadeIn * fadeOut, pointerEvents: "none" }}>
      <div
        style={{
          position: "absolute",
          bottom: 54,
          left: "50%",
          transform: `translateX(-50%) translateY(${slideY}px)`,
          background: BG,
          border: `1px solid ${BORDER_GOLD}`,
          borderTop: `2px solid ${GOLD}`,
          borderRadius: 10,
          padding: "12px 24px 15px",
          backdropFilter: "blur(14px)",
          boxShadow: "0 8px 42px rgba(0,0,0,0.7)",
          width: 620,
        }}
      >
        <div style={{
          color: GOLD, fontSize: 10, fontWeight: 800, fontFamily,
          textTransform: "uppercase", letterSpacing: "2px", marginBottom: 7,
        }}>
          {data.label}
        </div>
        <div style={{ color: "rgba(255,255,255,0.92)", fontSize: 13, fontWeight: 400, fontFamily, lineHeight: 1.5 }}>
          {data.text}
        </div>
        {data.text_hindi && (
          <div style={{
            color: "rgba(255,255,255,0.5)", fontSize: 11, fontWeight: 400,
            marginTop: 7, lineHeight: 1.5, fontFamily: devFont,
          }}>
            {data.text_hindi}
          </div>
        )}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
